import React, { type PropsWithChildren } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { theme } from '@garnish/constants';

/**
 * Floating buttons container for the bag screen.
 */
export const BagFloatingCtas = (props: PropsWithChildren) => {
  const { children } = props;
  const { bottom } = useSafeAreaInsets();
  const bottomPosition = useStyle(
    () => ({
      bottom: Platform.select({
        native: Math.max(bottom + theme.spacing['4'], theme.spacing['6']),
        default: theme.spacing['6'],
      }),
    }),
    [bottom],
  );

  return <View style={[styles.floatingCta, bottomPosition]}>{children}</View>;
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  floatingCta: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1,
    marginHorizontal: theme.spacing['4'],
    gap: theme.spacing['4'],
    flexDirection: 'row',
  },
});
